import { Store } from 'redux';
import { isExplorer } from 'utils';
import isWhitelisted, { WhitelistType } from 'components/Shared/whitelist';
import { createHref, IHref } from './href';
import { getPage } from 'components/Pagelayout/actions';
import { ThunkDispatch } from 'components/Shared/connect';

export * from './request';
export * from './href';

const MOUSE_LEFT = 0;
export function linkInterceptor(injector: (e: Event, elm: IHref, node: HTMLElement) => void) {
  return function interceptor(event: MouseEvent) {
    const e = event || window.event;
    if (e.button !== MOUSE_LEFT) {
      return;
    }
    const node = findParent('a', (e.target || e.srcElement) as Node) as HTMLAnchorElement;
    if (node) {
      injector(e, createHref(node), node);
    }
  };
}

function findParent(nodeType: string, node: Node | null): Node | undefined {
  if (node === null) {
    return undefined;
  }
  const compare = (el: Node) =>
    (el.nodeName || (el as Element).tagName).toLowerCase() === nodeType.toLowerCase();
  if (compare(node)) {
    return node;
  }
  let parent = node.parentNode;
  while (parent) {
    if (compare(parent)) {
      return parent;
    }
    parent = parent.parentNode;
  }
  return undefined;
}

const isExternal = (href: IHref) => href.host !== window.location.host;

export const reactInjector = (whitelist: WhitelistType, store: Store) => {
  return function injector(e: Event, href: IHref, node: HTMLAnchorElement) {
    if (
      e.defaultPrevented ||
      (e as MouseEvent).ctrlKey ||
      (e as MouseEvent).metaKey ||
      href.toString() === '' ||
      href.hash ||
      isExternal(href) ||
      !href.live ||
      !window.isReact ||
      node.target === '_blank' ||
      !isWhitelisted(whitelist, href)
    ) {
      return;
    }
    stopDefaultNavigation(e);
    void (store.dispatch as ThunkDispatch)(getPage(href));
  };
};

function stopDefaultNavigation(e: Event) {
  e.preventDefault();
  e.stopPropagation();
  if (isExplorer()) {
    document.execCommand('Stop');
  } else {
    window.stop();
  }
}
